// extracted by mini-css-extract-plugin
module.exports = {"leftSpace":"Login_leftSpace__5zya4"};